<template>
  <div>
    <home-mortgage-banner></home-mortgage-banner>
    <home-strength-intro
      :imgurl=cycleflex
      :isSecond=false
      slogan="周期灵活"
      description="只需上门1次，即可获得贷款，最快当天拿到钱，随借随还。"></home-strength-intro>
    <home-strength-intro
      :imgurl=lowinterest
      :isSecond=true
      slogan="低利息"
      description="日息最低为0.05%，利息合理，降低借贷成本。"></home-strength-intro>
    <home-strength-intro
      :imgurl=noworry
      :isSecond=false
      slogan="服务省心"
      description="服务站入驻满洲里、二连浩特、天津、青岛等口岸，提供便捷服务。"></home-strength-intro>
    <home-strength-intro
      :imgurl=bigrepo
      :isSecond=true
      slogan="超大仓库"
      description="自营及合作仓库面积12万平米，可存储木材20万立方米。"></home-strength-intro>
    <home-strength-intro
      :imgurl=lowthreshold
      :isSecond=false
      slogan="申请门槛低"
      description="有货即贷借，签约简单，只需提供质押人基础信息。"></home-strength-intro>
    <home-strength-intro
      :imgurl=safety
      :isSecond=true
      slogan="安全保障"
      description="客户的资料由专业档案室管理，保证资料信息安全，交易协议具有法律保障。"></home-strength-intro>
  </div>
</template>

<script>
  import HomeStrengthIntro from '../HomeServiceIntro.vue'
  import HomeMortgageBanner from './HomeMortgageBanner'
  export default {
    name: 'HomeMortgageContent',
    components: {
      HomeMortgageBanner, HomeStrengthIntro
    },
    data () {
      return {
        cycleflex: '/static/img/service_intro/mortgage/cycle-flex.png',
        lowinterest: '/static/img/service_intro/mortgage/low-interest.png',
        noworry: '/static/img/service_intro/mortgage/no-worry.png',
        bigrepo: '/static/img/service_intro/mortgage/big-repo.png',
        lowthreshold: '/static/img/service_intro/mortgage/low-threshold.png',
        safety: '/static/img/service_intro/mortgage/safety.png'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// HomeMortgageContent.vue?2f08f844